import { Component, ElementRef, HostListener, Input } from '@angular/core';
import { EMOJI_CATEGORIES } from './emoji-data';

/**
 * Smiley button + popup for adding an emoji to a text box. Pass the box as
 * `target` (a template ref to a <textarea> or <input>): the emoji is inserted
 * at the caret / over the selection and an `input` event is dispatched, so
 * ngModel bindings on the box update without any code in the parent.
 */
@Component({
  selector: 'app-social-emoji-picker',
  templateUrl: './social-emoji-picker.component.html',
  styleUrls: ['./social-emoji-picker.component.scss'],
  standalone: false,
})
export class SocialEmojiPickerComponent {
  @Input() target: HTMLTextAreaElement | HTMLInputElement | null = null;

  categories = EMOJI_CATEGORIES;
  activeIndex = 0;
  open = false;

  constructor(private host: ElementRef<HTMLElement>) {}

  toggle(): void {
    this.open = !this.open;
  }

  selectCategory(index: number): void {
    this.activeIndex = index;
  }

  pick(emoji: string): void {
    const box = this.target;
    if (!box) {
      return;
    }
    const start = box.selectionStart ?? box.value.length;
    const end = box.selectionEnd ?? start;
    box.setRangeText(emoji, start, end, 'end');
    box.dispatchEvent(new Event('input', { bubbles: true }));
    box.focus();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.open && !this.host.nativeElement.contains(event.target as Node)) {
      this.open = false;
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.open = false;
  }
}
